// src/routes/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UserContext } from '../context/UserContext';
import { ROLES } from '../constants/roles';
import logger from '../utils/logger';

const ProtectedRoute = ({ allowedRoles = [], requiredPermission = null, children }) => {
  const { userRole, userPermissions, loading, currentUser } = useContext(UserContext);
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!currentUser) {
      return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 1. Acceso Universal para Super Admin
  if (userRole === ROLES.SUPER_ADMIN) return children;

  if (userRole === ROLES.PENDIENTE) {
    return <Navigate to="/awaitRole" replace />;
  }

  // 2. Verificación por Roles (Si se define explícitamente)
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" replace state={{ attemptedPath: location.pathname }} />;
    }
  }

  // 3. Verificación por Permisos Dinámicos (Matriz de App)
  if (requiredPermission) {
    if (!userPermissions.includes(requiredPermission)) {
        logger.warn(`Acceso denegado por permiso: Falta '${requiredPermission}' para el usuario.`);
        return <Navigate to="/unauthorized" replace state={{ attemptedPath: location.pathname }} />;
    }
  }

  return children;
};

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  requiredPermission: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;